

import React, { useState, useEffect, createContext, useRef } from "react";

import { PrimeReactProvider } from 'primereact/api';
import { BlockUI } from 'primereact/blockui';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';

import './App.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'primereact/resources/primereact.css';
import "primereact/resources/themes/lara-dark-blue/theme.css"

import axios from './axios';

import { BrowserRouter as Router, Route, Routes, Navigate, Outlet } from "react-router-dom";

import { useMountEffect, useUnmountEffect, useMatchMedia } from "primereact/hooks";

import useWebSocket from 'react-use-websocket';
import AppContext from "./Context/AppContext";
import Login from "./Pages/Login";
import Layout from "./Pages/Layout";
import Codes from "./Pages/Codes";
import Reports from "./Pages/Reports";
import Users from "./Pages/Users";
import Contacts from "./Pages/Contacts";
import Logs from "./Pages/Logs"

const WS_URL = (window.location.protocol === "http:" ? "ws:" : "wss:") + "//" + window.location.hostname + process.env.REACT_APP_WEBSOCKET_APPENDIX;

const App = () => {
	const style = {
		ripple: false,
	};

	const toast = useRef(null);
	const didUnmount = useRef(false);
	const [blocked, setBlocked] = useState(false);

	const [user, setUser] = useState(null);
	const [loginBlocked, setLoginBlocked] = useState(true);

	const [message, setMessage] = useState(true);
	const [websocketBlocked, setWebsocketBlocked] = useState(true);

	const [codeExecution, setCodeExecution] = useState(false);
	const [textMessageStatus, setTextMessageStatus] = useState(0);
	const [phoneDialStatus, setPhoneDialStatus] = useState(0);

	const { sendMessage } = useWebSocket(WS_URL, {
		onOpen: () => {
			setWebsocketBlocked(false)
		},
		onClose: (event) => {
			console.log(event)
			setWebsocketBlocked(true)
		},
		onMessage: (event) => {
			setMessage(JSON.parse(event.data))
		},
		shouldReconnect: () => {
			return didUnmount.current === false;
		},
		reconnectAttempts: 999999,
		reconnectInterval: 3000,
	});

	useMountEffect(() => {
		authenticate();
	})

	useUnmountEffect(() => {
		didUnmount.current = true;
	})

	const authenticate = async () => {
		try {
			const response = await axios.post('/users/authenticate');
			if (response.data.success) {
				setUser(response.data.user)
				setLoginBlocked(false)
			}
		} catch (error) {
			setLoginBlocked(false)
		}
	};

	const isDesktop = useMatchMedia(`screen and (min-width: 992px)`);

	return (
		<PrimeReactProvider value={style}>
			<AppContext.Provider value={{ message, sendMessage, toast, blocked, setBlocked, user, setUser, websocketBlocked, isDesktop, setCodeExecution, setTextMessageStatus, setPhoneDialStatus }}>
				<Router basename={process.env.REACT_APP_SUBFOLDER}>
					<Routes>
						<Route path="*" element={
							<>
								<BlockUI blocked={blocked || loginBlocked || websocketBlocked} fullScreen template={<ProgressSpinner />} />
								<BlockUI blocked={codeExecution} fullScreen template={
									<div className="flex flex-column gap-3">
										<div className="flex align-items-center gap-2">
											{textMessageStatus === 0 ? (
												<div><i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i></div>
											) : textMessageStatus === 1 ? (
												<div><i className="pi pi-check" style={{ fontSize: '2rem', color: 'var(--green-500)' }}></i></div>
											) : (
												<div><i className="pi pi-times" style={{ fontSize: '2rem', color: 'var(--red-500)' }}></i></div>
											)}
											<h1 className="m-0">Text Message</h1>
										</div>
										<div className="flex align-items-center gap-2">
											{phoneDialStatus === 0 ? (
												<div><i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i></div>
											) : phoneDialStatus === 1 ? (
												<div><i className="pi pi-check" style={{ fontSize: '2rem', color: 'var(--green-500)' }}></i></div>
											) : (
												<div><i className="pi pi-times" style={{ fontSize: '2rem', color: 'var(--red-500)' }}></i></div>
											)}
											<h1 className="m-0">Phone Dial</h1>
										</div>
									</div>
								} />
								<Toast ref={toast} className="mt-8 md:mr-5 top-0 right-0" />
								<Outlet />
							</>}>

							{loginBlocked === true ? (
								<></>
							) : user === null ? (
								<Route path="*">
									<Route path="login" element={<Login />} />

									<Route path="*" element={<Navigate to="/login" />} />
								</Route>
							) : (
								<Route path="*" element={<Layout />}>
									<Route path="codes" element={<Codes />} />
									<Route path="reports" element={<Reports />} />
									<Route path="users" element={<Users />} />
									<Route path="contacts" element={<Contacts />} />
									<Route path="logs" element={<Logs />} />

									<Route path="*" element={<Navigate to="/codes" />} />
								</Route>
							)}
						</Route>
					</Routes>
				</Router>
			</AppContext.Provider>
		</PrimeReactProvider>
	);
}

export default App;


/*
{loading ? (
							<Route path="*" element={<Loading />} />
						) : (
							account == null ? (
								<Route path="*">
									<Route path="login" element={<Login setAccount={setAccount} />} />

									<Route path="*" element={<Navigate to="/login" />} />
								</Route>
							) : account.permissions > 0 ? (
								<Route path="*" element={<Layout account={account} setAccount={setAccount} />}>
									<Route path="codes" element={<Codes />} />
									<Route path="forms" element={<Forms />} />
									<Route path="accounts" element={<Accounts />} />
									<Route path="contacts" element={<Contacts />} />
									<Route path="logs" element={<Logs />} />

									<Route path="*" element={<Navigate to="/codes" />} />
								</Route>
							) : (
								<Route path="*" element={<Layout account={account} setAccount={setAccount} />}>
									<Route path="codes" element={<Codes />} />

									<Route path="*" element={<Navigate to="/codes" />} />
								</Route>
							))}
*/